"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _r10SourceLibrary = require("r10-source-library");
var _services = require("../../services");
var _shareRecommendationSelectors = require("../../store/shareRecommendation/shareRecommendationSelectors");
var _shareRecommendationActions = require("../../store/shareRecommendation/shareRecommendationActions");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var EmailInput = function EmailInput() {
  var breakpoints = (0, _r10SourceLibrary.useBreakpoints)();
  var dispatch = (0, _reactRedux.useDispatch)();
  var isShown = (0, _reactRedux.useSelector)(_shareRecommendationSelectors.isEmailInputShown);
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    inputText = _useState2[0],
    setInputText = _useState2[1];
  var _React$useState = _react.default.useState(),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    inputState = _React$useState2[0],
    setInputState = _React$useState2[1];
  var onSendHandle = function onSendHandle() {
    var parsedData = {
      type: 'email',
      subject: 'Your Recommendation',
      status: 'pending',
      to: inputText
    };
    dispatch((0, _shareRecommendationActions.sendRecommendation)(parsedData));
  };
  var onChangeHandle = function onChangeHandle(value) {
    setInputText(value);
    setInputState('');
  };
  var validateInput = function validateInput() {
    if (!inputText.match(/^[a-zA-Zα-ωΑ-Ω0-9._-]+@[a-zA-Z_-]+?\.[a-zA-Z]{2,3}$/)) return setInputState('error');
    setInputState();
  };
  return isShown && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 4
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, {
    appearance: "secondary"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 1,
    justify: "center"
  }, _services.locale.localeString('ShareRecommendation.Title')), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    noGutters: true,
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 12,
    colMd: 7
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.TextInputWithLabel, {
    state: inputState,
    fieldWrapper: {
      width: 'default',
      stateText: _services.locale.localeString('ShareRecommendation.errorText')
    },
    textInput: {
      type: 'text',
      id: 'share-input',
      placeholder: _services.locale.localeString('ShareRecommendation.InputPlaceholder'),
      value: inputText,
      onChange: function onChange(e) {
        return onChangeHandle(e.target.value);
      },
      onBlur: validateInput
    }
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 12,
    colMd: 3
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 2,
      left: breakpoints.sm ? 0 : 3
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, _extends({
    text: _services.locale.localeString('ShareRecommendation.SendButtonText'),
    appearance: "alt1"
  }, inputText.length < 1 && {
    state: 'disabled'
  }, !inputState && {
    onClick: onSendHandle
  })))))));
};
var _default = EmailInput;
exports.default = _default;